import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetModulesList = (teamId?: string, disciplinesIds?: string[]) => {
    const [resp, setResp] = useState<any>([]);
    const [respUntranslated, setRespUntranslated] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {

        if (!teamId || !disciplinesIds?.length) return
        setIsLoading(true)

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModulesList')
            .get()
            .addQuery('teamId', teamId || '')
            .addQuery('lMSModuleDisciplines', disciplinesIds || [])
            .send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r?.data)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId, disciplinesIds])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    return {modules: resp, isLoading, error};
}
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetModulesList = (teamId?: string, disciplinesIds?: string[]) => {
    const [resp, setResp] = useState<any>([]);
    const [respUntranslated, setRespUntranslated] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {

        if (!teamId || !disciplinesIds?.length) return
        setIsLoading(true)

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetModulesList')
            .get()
            .addQuery('teamId', teamId || '')
            .addQuery('lMSModuleDisciplines', disciplinesIds || [])
            .send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setRespUntranslated(r?.data)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [teamId, disciplinesIds])

    useEffect(() => {
        setResp(API.toLang(respUntranslated, i18n.language) as any)
    }, [respUntranslated, i18n])

    return {modules: resp, isLoading, error};
}
